import  DigitacionSolicitud  from '../containers/digitacionSolicitud';

import React from 'react';
import {useJumboApp} from "@jumbo/hooks";
import {LAYOUT_NAMES} from "../../../layouts/layouts";


const DigitacionSolicitudPage = () => {
  const {setActiveLayout} = useJumboApp();

  React.useEffect(() => {
      setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);
  return (
      <div>
            <DigitacionSolicitud/>
      </div>
  );
};

export default DigitacionSolicitudPage;